import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Digitalled(props) {
  return (
    <section className="solutionled tekrevol_gray_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Why Choose">
              <h2>Why Choose TekRevol For Digital Health Solutions?</h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              At TekRevol, we understand that organizations and individual
              healthcare providers need digital solutions to modernize their
              processes. That’s how they can improve patient care and reduce the
              overall cost of operations. With our proven skills and experience,
              we can build custom digital health solutions that address the
              unique challenges faced by the healthcare industry.
            </p>
            <p>
              We aim to enhance the patient experience by providing advanced
              medical software integration that is highly effective and
              resourceful. By partnering with us, healthcare businesses can
              update workflows, reduce waiting times, and improve patient care
              through digital health solutions.
            </p>
            <div className="btn_talk">
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book a Free Consultation!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Digitalled;
